import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatSort',
  standalone: true,
})
export class ChatSortPipe implements PipeTransform {
  transform(array: any[], searchTerm: string, property: string): any[] {
    if (!array || array.length === 0) return array;

    let filteredArray = array;

    // Handle filtering
    if (searchTerm && property) {
      const lowerSearch = searchTerm.toLowerCase();
      filteredArray = array.filter(item =>
        item[property]?.toLowerCase().includes(lowerSearch)
      );
    }

    return filteredArray.slice().sort((a, b) => {
      const aValue = a['creationTime'] || '';
      const bValue = b['creationTime'] || '';

      if (!aValue) return 1;
      if (!bValue) return -1;

      return bValue.localeCompare(aValue); // Descending
    });
  }
}
